"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBurnedBudgetCombinationKey = void 0;
exports.serializeCustomerBurnedBudgetCombinationKey = serializeCustomerBurnedBudgetCombinationKey;
exports.deserializeCustomerBurnedBudgetCombinationKey = deserializeCustomerBurnedBudgetCombinationKey;
function serializeCustomerBurnedBudgetCombinationKey(key) {
    return `${key.budgeted}-${key.em}-${key.ops}`;
}
function deserializeCustomerBurnedBudgetCombinationKey(serialized) {
    const splitted = serialized.split("-");
    while (splitted.length < 3) {
        splitted.push("");
    }
    return new CustomerBurnedBudgetCombinationKey(splitted[0] === "true", splitted[1] === "true", splitted[2] === "true");
}
class CustomerBurnedBudgetCombinationKey {
    constructor(budgeted, em, ops) {
        this.budgeted = budgeted;
        this.em = em;
        this.ops = ops;
    }
    getLabel() {
        const keys = Object.entries(this)
            .filter((entry) => entry[1] === true)
            .map((entry) => entry[0]);
        return keys.length > 0 ? keys.join(" & ") : "other";
    }
}
exports.CustomerBurnedBudgetCombinationKey = CustomerBurnedBudgetCombinationKey;
//# sourceMappingURL=CustomerBurnedBudgetCombinationKey.js.map